/**
 * @generated SignedSource<<e32982c52dfaf15e124228055e64b085>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "concreteType": "SendUnlockInstructionsPayload",
    "kind": "LinkedField",
    "name": "sendUnlockInstructions",
    "plural": false,
    "selections": [
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "success",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "needsAuthentication",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ValidationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "field",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "messages",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "MutationResult",
        "abstractKey": "__isMutationResult"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendUnlockInstructionsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendUnlockInstructionsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b1f20b543f3cde805664b207627b28bd",
    "id": null,
    "metadata": {},
    "name": "SendUnlockInstructionsMutation",
    "operationKind": "mutation",
    "text": "mutation SendUnlockInstructionsMutation(\n  $email: String!\n) {\n  sendUnlockInstructions(email: $email) {\n    ... on MutationResult {\n      __isMutationResult: __typename\n      success\n      notice\n      needsAuthentication\n      errors {\n        field\n        messages\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "68c54634fffebadc2283b8d0f528f944";

module.exports = node;
